/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable consistent-return */
import { Text } from '@leverege/ui-elements'
import moment from 'moment'
import React, { useMemo } from 'react'
import S from '../components/Tables.css'

const getDuration = ( seconds, hide = true ) => {
  const hour = Math.floor( ( Math.abs( seconds ) / ( 60 * 60 ) ) % 24 )
  const min = Math.floor( ( Math.abs( seconds ) / 60 ) % 60 )
  const sec = Math.floor( ( Math.abs( seconds ) ) % 60 )

  if ( hide ) return `${hour ? `${hour}h` : ''} ${min ? `${min}m ` : ''}${sec}s`
  return `${min}m ${sec}s`
}

const formatAvgs = ( avg ) => {
  if ( avg === undefined ) return '-'
  if ( avg === 0 ) return avg
  return Intl.NumberFormat( undefined, {
    minimumFractionDigits : 1,
  } ).format( avg )
}

const processStageData = ( stageData ) => {
  if ( !stageData ) return []
  
  return Object.entries( stageData ).map( ( [ _, { 
    startTime, 
    endTime, 
    avgWorkerCountBySubcategory, 
    ctGroup, 
    ctGroupDescription, 
    actualDuration 
  } ] ) => ( {
    ctGroup,
    ctGroupDescription,
    cycleStartTime : startTime ? moment( startTime ).format( 'YYYY-MM-DD HH:mm' ) : '-',
    cycleEndTime : endTime ? moment( endTime ).format( 'YYYY-MM-DD HH:mm' ) : '-',
    cycleDuration : getDuration( actualDuration ),
    avgDirLaborProd : formatAvgs( avgWorkerCountBySubcategory?.productionAssociate ),
    avgDirLaborCrane : formatAvgs( avgWorkerCountBySubcategory?.craneOperator ),
    avgDirLaborTeam : formatAvgs( avgWorkerCountBySubcategory?.teamLeader ),
    avgDirLaborResin : formatAvgs( avgWorkerCountBySubcategory?.resinMachineOperator ),
    avgDirLaborTrainer : formatAvgs( avgWorkerCountBySubcategory?.trainer ),
    avgIndLaborProdSup : formatAvgs( avgWorkerCountBySubcategory?.supervisor ),
    avgIndLaborProdCtrl : formatAvgs( avgWorkerCountBySubcategory?.productionControl ),
    avgIndLaborQuality : formatAvgs( avgWorkerCountBySubcategory?.quality ),
    avgIndLaborTraining : formatAvgs( avgWorkerCountBySubcategory?.training ),
    avgIndLaborEng : formatAvgs( avgWorkerCountBySubcategory?.engineeringMaintenanceEhs ),
    avgUncategorized : formatAvgs( avgWorkerCountBySubcategory?.uncategorized ),
  } ) )
}

const useEventsTable = ( props ) => {
  const { item } = props
  const jobId = item?.data?.jobId

  const psData = useMemo( () => processStageData( item?.data?.pressureSideJob?.data?.stage ),
    [ item?.data?.pressureSideJob?.data?.stage ]
  )

  const ssData = useMemo( () => processStageData( item?.data?.suctionSideJob?.data?.stage ),
    [ item?.data?.suctionSideJob?.data?.stage ]
  )

  const bndData = useMemo( () => processStageData( item?.data?.bondedBladeJob?.data?.stage ),
    [ item?.data?.bondedBladeJob?.data?.stage ]
  )

  const baseColumns = [
    {
      id : 'ctGroup',
      Header : <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">Group</Text>,
      accessor : item => item.ctGroup,
    },
    {
      id : 'ctGroupDescription',
      Header : <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">Group Description</Text>,
      accessor : item => item.ctGroupDescription,
    },
    {
      id : 'cycleStartTime',
      Header : <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">Cycle Start Time</Text>,
      accessor : item => item.cycleStartTime,
    },
    {
      id : 'cycleEndTime',
      Header : <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">Cycle End Time</Text>,
      accessor : item => item.cycleEndTime,
    },
    {
      id : 'cycleDuration',
      Header : <Text className={S.ellipsizeLeft} variant="columnHeaderCustom">Cycle Duration Time</Text>,
      accessor : item => item.cycleDuration,
    },
  ]

  // Note: Labor columns can be added here when needed
  const columns = [ ...baseColumns ]

  return {
    jobId,
    psData,
    ssData,
    bndData,
    columns,
  }
}

export default useEventsTable
